import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

const baseRoot: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  p: 0,
  transition: "all 0.2s ease",
  "& svg": {
    display: "block",
    flexShrink: 0,
  },
};

export const outlined: SxProps<Theme> = (theme) => ({
  ...baseRoot,
  width: 34,
  height: 34,
  borderRadius: 1.125,
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: "background.paper",
  color: "text.secondary",
  "&:hover": {
    bgcolor: alpha(theme.palette.primary.main, 0.08),
    color: "primary.main",
    borderColor: alpha(theme.palette.primary.main, 0.3),
  },
});

export const outlinedDanger: SxProps<Theme> = (theme) => ({
  ...baseRoot,
  width: 34,
  height: 34,
  borderRadius: 1.125,
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: "background.paper",
  color: "text.secondary",
  "&:hover": {
    bgcolor: alpha(theme.palette.error.main, 0.1),
    color: "error.main",
    borderColor: theme.palette.error.main,
  },
});

export const plain: SxProps<Theme> = (theme) => ({
  ...baseRoot,
  width: 40,
  height: 40,
  borderRadius: 1.25,
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: "background.paper",
  color: "text.secondary",
});

export const ghost: SxProps<Theme> = {
  ...baseRoot,
  width: "auto",
  height: "auto",
  minWidth: 0,
  border: "none",
  bgcolor: "transparent",
  color: "primary.main",
  "&:hover": {
    bgcolor: "transparent",
  },
};
